<template lang="pug">
    v-content
        .rtl
            v-layout(row py-2)
                v-flex
                    img(alt="Vue logo" style="margin: 0 auto; display: block; height: 130px;" src="@/assets/mendi_logo.jpg")
            //v-layout(row wrap px-2)
                v-flex(md5 xs12 px-2)
                    v-text-field(v-model='searchText1' label='לקוח' append-icon='search' @keyup='search($event)')
                v-flex(md5 xs12 px-2)
                    v-text-field(v-model='searchText2' label='פריט' append-icon='search' @keyup='search($event)')
                v-flex(md2 xs12 pt-2)
                    v-layout(row wrap)
                        v-flex(xs6 pl-1)
                            //templete
                            v-btn(block @click='search()'  color="red lighten-1" dark )  חפש
                        v-flex(xs6 pr-1).-text-xs-left
                            //templete
                            v-btn(block @click='clean()'  color="blue-grey lighten-2" dark)  נקה

            v-flex(v-if="count")  בוצעו {{count}} חיפושים
        v-data-table#mendi-table.elevation-1(:headers='headers' :items='desserts' :loading='loading' :rows-per-page-items="rowsPerPageItems")
            v-progress-linear(slot='progress' color='blue' indeterminate='')
            template(slot='items' slot-scope='props')
                td.text-xs-right(:style="{background : props.item.c ? '#c3c3c3' : ''}" ) {{ (props.item.text||{}).search1 }}
                td.text-xs-right(:style="{background : props.item.c ? '#c3c3c3' : ''}" ) {{ (props.item.text||{}).search2 }}
                td.text-xs-right(:style="{background : props.item.c ? '#c3c3c3' : ''}" ) {{ props.item.results_count }}
                td.text-xs-right(:style="{background : props.item.c ? '#c3c3c3' : ''}" ) {{ props.item.email }}
                td.text-xs-right(:style="{background : props.item.c ? '#c3c3c3' : ''}" ) {{ props.item.c }}
                td.text-xs-right(:style="{background : props.item.c ? '#c3c3c3' : ''}" ) {{ props.item.created_at }}


</template>

<script>
    export default {
        data () {
            return {
                loading : false,
                count : 0,
                searchText1: '',
                searchText2: '',
                rowsPerPageItems: [15, 30, 60, 100, 1000],
                /*pagination: {
                    rowsPerPage: 20
                },*/
                headers: [
                    { text: 'לקוח', value: 'text.search1' },
                    { text: 'פריט', value: 'text.search2' },
                    { text: 'מספר תוצאות', value: 'results_count' },
                    { text: 'משתמש', value: 'email' },
                    { text: 'כמות חיפושים אי פעם', value: 'c' },
                    { text: 'תאריך', value: 'created_at' },
                ],
                desserts: [

                ]
            }
        },
        created() {
          document.title = 'SendiSettings';

          this.$socket.on('*', (packet) => {
                // console.log(packet)
                let channel = packet.data[0];
                let data = packet.data[1];
                let $uniqid = data.$uniqid;
                if($uniqid) {
                    return this.$socket.res(data);
                }
                this.sockets(channel, data);
            });

            // console.log('this.$user', this.$user);
            this.$emit('update:loading', false);


            // this.searchText1 = 'מ';
            this.search()
        },
        beforeRouteLeave(to, from, next) {
            this.$socket.off('*');
            this.$emit('update:loading', true);
            next();
        },


        methods : {
            clean : function () {
                this.searchText1 = '';
                this.searchText2 = '';
            },
            search : function ($event) {
                this.loading = true;
                this.$emit('update:loading', true);

                this.$socket.req('mendi.statistics.all', {user: this.$user}).then(data => {

                    // console.log(data)



                    this.desserts =  data.entities;

                    this.count = data.entities.length;
                    this.loading = false;
                    this.$emit('update:loading', false);
                });

            },
            sockets : function (channel, data) {
                let channels = {
                  'sum.channel' : (/*data*/) => {
                        //console.log('sum.channel', data)
                    }
                };
                if(!channels[channel]) {
                    return console.log('Socket channel not found:', channel);
                }

                return channels[channel](data);
            },
        }
    }
</script>


<style lang="sass">

    #mendi-table .v-table__overflow
        /*height: 300px;*/
        overflow-y: auto
        /*direction: rtl;*/


    #mendi-table .v-datatable.v-table
        direction: rtl


    #mendi-table
        .v-datatable__actions
            direction: ltr
        table.v-table tbody td:first-child, table.v-table tbody td:not(:first-child), table.v-table tbody th:first-child, table.v-table tbody th:not(:first-child), table.v-table thead td:first-child, table.v-table thead td:not(:first-child), table.v-table thead th:first-child, table.v-table thead th:not(:first-child)
            padding: 0 5px
            text-align: right !important


</style>